/* unplugin-vue-components disabled */import { render } from "./RightModal.vue?vue&type=template&id=2fa987c8&scoped=true"
import script from "./RightModal.vue?vue&type=script&lang=js"
export * from "./RightModal.vue?vue&type=script&lang=js"

import "./RightModal.vue?vue&type=style&index=0&id=2fa987c8&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa987c8"]])

export default __exports__